// The hover tooltip of the history chart and the sparklines. Its look is .chart-tooltip in components.css.

// series ("astral" or "azure") picks the value color. compact is the sparkline size.
export function createTooltip(container, { series, compact = false, attributes = {} } = {}) {
  const tooltip = document.createElement("div")
  tooltip.className = compact ? "chart-tooltip chart-tooltip--compact" : "chart-tooltip"
  tooltip.dataset.series = series
  for (const [name, value] of Object.entries(attributes)) tooltip.setAttribute(name, value)
  hideTooltip(tooltip)
  container.appendChild(tooltip)
  return tooltip
}

// title is the timestamp. heading is an optional series name. rows are [name, value] pairs.
// A row without a name is the value alone. No rows reads "No data".
export function fillTooltip(tooltip, { title, heading, rows }) {
  const parts = [element("chart-tooltip__title", title)]
  if (heading) parts.push(element("chart-tooltip__heading", heading))

  if (rows.length === 0) parts.push(element("chart-tooltip__name", "No data"))
  for (const [name, value] of rows) {
    const row = element("chart-tooltip__row")
    if (name) row.appendChild(element("chart-tooltip__name", name, "span"))
    row.appendChild(element("chart-tooltip__value", value, "span"))
    parts.push(row)
  }

  tooltip.replaceChildren(...parts)
}

// Right of x, or left of it when the tooltip would pass the container's right edge.
// It is measured while hidden, so the size is real. top may be a function of the tooltip's height.
export function positionTooltip(tooltip, { x, top, width }) {
  tooltip.style.visibility = "hidden"
  tooltip.style.display = "block"
  const tipWidth = tooltip.offsetWidth
  const left = x + tipWidth + 8 > width ? x - tipWidth - 8 : x + 8

  tooltip.style.left = `${Math.max(0, left)}px`
  tooltip.style.top = `${typeof top === "function" ? top(tooltip.offsetHeight) : top}px`
  tooltip.style.visibility = "visible"
}

export function hideTooltip(tooltip) {
  tooltip.style.display = "none"
}

function element(className, text, tag = "div") {
  const node = document.createElement(tag)
  node.className = className
  if (text != null) node.textContent = text
  return node
}
